import React, { ReactNode, JSX } from "react";
import styles from "./Section.module.css";

interface SectionProps {
  title?: string;
  children: ReactNode;
  TitleIcon?: React.ElementType;
  headerRightElement?: JSX.Element;
  titleAction?: JSX.Element;
  variant?: "transparent" | "solid";
}

const Section: React.FC<SectionProps> = ({
  title,
  children,
  TitleIcon,
  headerRightElement,
  titleAction,
  variant = "solid",
}) => {
  return (
    <section className={styles["container"]}>
      {title && (
        <div className={styles["section-header"]}>
          <div className={styles["section-title"]}>
            <h3 className={``}>{title}</h3>
            {TitleIcon && <TitleIcon className={styles.icon} />}
            {titleAction && titleAction}
          </div>

          {headerRightElement}
        </div>
      )}
      <div
        className={`${styles[`section-content`]} ${styles[`section-content--${variant}`]}`}
      >
        {children}
      </div>
    </section>
  );
};

export default Section;
